export const TEMPLATE_SPREADSHEET_IDS = {
  'Narrative Short - English': '1iFvMLnC6Y9zyPiqE2hvo_1Q8qW78rJNo-iN7LtPy25c',
  'Narrative Short - Bilingual': '170DQfqOBcIS8AkXj96oG--mycj9IkWfCVROqzar84os',
  'Narrative Short - Hebrew': '1-LMXdRg_hs4x0Wg5EdOCMYBPogDPFpFXZS1IJr7ysAg',
  'Narrative Feature - Hebrew': '1cSut0MmmKTrieD1RPAEYfQtsjuMChdyjk88ZTa6Yw18',
  'Narrative Feature - Bilingual': '1mjbBspApME5Wngqr2Dv0Yt0BTADqoPRiDZj-EHARbRA',
} as const;

export type TemplateName = keyof typeof TEMPLATE_SPREADSHEET_IDS;

export const TEMPLATE_NAMES: TemplateName[] = Object.keys(TEMPLATE_SPREADSHEET_IDS) as TemplateName[];

export function getTemplateSpreadsheetId(name: TemplateName): string {
  return TEMPLATE_SPREADSHEET_IDS[name];
}
